import { useTranslation } from "react-i18next";
import { useSiteInfo } from "@/hooks/useSiteInfo";

export default function TopBar() {
  const { t } = useTranslation();
  const site = useSiteInfo();

  return (
    <div className="hidden md:block w-full bg-foreground-950 text-background-50/80 text-xs">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-9 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="inline-flex w-1.5 h-1.5 rounded-full bg-accent-500" />
          <span className="tracking-wide">{t("common.topbar.tagline")}</span>
        </div>
        <div className="flex items-center gap-6">
          <a
            href={site.telLink}
            className="inline-flex items-center gap-2 hover:text-accent-300 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[12px]" />
            </span>
            TEL · {site.tel}
          </a>
          <a
            href={site.emailLink}
            className="inline-flex items-center gap-2 hover:text-accent-300 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-fill text-[12px]" />
            </span>
            {site.email}
          </a>
        </div>
      </div>
    </div>
  );
}